export default "__VITE_ASSET__d8383159__"